import React, { useState, useEffect, useContext } from "react";
import { 
    Dialog,
    DialogTitle,
    DialogContent,
    Grid,
    Button,
    Typography,
    TextField,
    Divider
} from "@material-ui/core";
import axios from "axios";
import { ResetPasswordDialog } from './ResetPasswordDialog';
import { AppContext } from '../../context/AppContext';

export const UserDialog = ({ open, toggle, user, org, orgs, reload }) => {
    const appCtx = useContext(AppContext);
    const [resetPassOpen, setResetPassOpen] = useState(false);
    const [error, setError] = useState('');
    const [name, setName] = useState(user?.name ?? '');
    const [email, setEmail] = useState(user?.email ?? '');
    const [password, setPassword] = useState('');
    useEffect(() => {
        setName(user?.name ?? '');
        setEmail(user?.email ?? '');
    }, [user]);

    const _toggle = () => {
        setError('');
        toggle();
    }

    const updateUser = async () => {
        if (user) { // Update user
            let userData = user;
            userData.name = name;
            userData.email = email;

            await axios.patch('users', userData).then(result => {
                if (result.data && result.data.response === true) {
                    reload();
                    _toggle();

                    appCtx.setAlert({ type: 'success', message: 'Updated user' });
                } else {
                    appCtx.setAlert({ type: 'error', message: 'Failed to update user' });
                }
            }).catch(e => {
                appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to update user' });
            });

            
        } else { // Create new user
            let userData = { name: name, email: email, organization_id: org.id, password: password };

            await axios.post('auth/register', userData).then(result => {
                if (result.data && result.data.status === "success") {
                    reload();
                    _toggle();

                    appCtx.setAlert({ type: 'success', message: 'Created new user' });
                } else {
                    appCtx.setAlert({ type: 'error', message: 'Failed to create new user' });
                }
            }).catch(e => {
                appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to create new user' });
            });

            
        }
    }

    const deleteUser = async () => {
        if (user) { // Update user
            await axios.delete(`users?id=${user.id}`, undefined).then(result => {
                if (result.data && result.data.response === true) {
                    reload();
                    _toggle();

                    appCtx.setAlert({ type: 'success', message: 'Deleted user' });
                } else {
                    appCtx.setAlert({ type: 'error', message: 'Failed to delete user' });
                }
            }).catch(e => {
                appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to delete user' });
            });

            
        } else { // Create new user
            let userData = { name: name, email: email, organization_id: org.id, password: password };

            await axios.post('auth/register', userData).then(result => {
                if (result.data && result.data.status === "success") {
                    reload();
                    _toggle();
                
                    appCtx.setAlert({ type: 'success', message: 'Created user' });
                } else {
                    appCtx.setAlert({ type: 'error', message: 'Failed to create user' });
                }
            }).catch(e => {
                appCtx.setAlert({ type: 'error', message: e?.data?.message ?? 'Failed to create user' });
            });

            
        }
    };

    const toggelResetPass = () => {
        setResetPassOpen(!resetPassOpen);
    };

    const userOrgs = user?.organizations ? orgs.filter(o => user.organizations.find(uo => uo.organization_id === o.id)) : [];

    return (
        <>
            <Dialog open={open} onClose={_toggle} maxWidth="lg" fullWidth>
                <DialogTitle>{user ? user.name : 'User'}</DialogTitle>
                <DialogContent>
                    <Grid container spacing={4} direction="column">
                        {error && error != '' && (
                            <Grid item>
                                <Typography variant="body1" style={{ color: 'red' }}>{error}</Typography>
                            </Grid>
                        )}
                        <Grid item>
                            <Grid container spacing={2}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TextField label="Name" fullWidth value={name} onChange={(e) => setName(e.target.value)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField label="Email" fullWidth value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </Grid>
                                    {!user && (
                                        <Grid item xs={12}>
                                            <TextField label="Password" fullWidth value={password} onChange={(e) => setPassword(e.target.value)} />
                                        </Grid>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={2}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography variant="h6">Organizations</Typography>
                                        {userOrgs.map(org => (
                                            <Typography variant="body1">{org.name}</Typography>
                                        ))}
                                        <Divider />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={2}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Typography variant="h6">Permissions</Typography>
                                        {user?.permissions.map(per => (
                                            <Typography variant="body1">{per.permission}</Typography>
                                        ))}
                                        <Divider />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container spacing={2} direction="row" justify="space-between">
                                <Grid item>
                                    <Button onClick={_toggle} variant="text" color="secondary">Cancel</Button>
                                </Grid>
                                <Grid item>
                                    <Button onClick={toggelResetPass} variant="text" color="secondary">Reset Password</Button>
                                    <Button onClick={deleteUser} variant="text" color="secondary">Delete</Button>
                                    <Button onClick={updateUser} variant="text" color="primary">Save</Button>
                                </Grid>
                            </Grid>                            
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        
            <ResetPasswordDialog open={resetPassOpen} toggle={toggelResetPass} user={user} resetPass={_toggle} />
        </>
    );
};
export default UserDialog;